import AgentStatusReason from 'models/modal/agent_status_reason';

export function openStatusReasonModal(context) {
  context.stores.modal.set(AgentStatusReason.create());
}
